import { type ProgressData } from '../types';

import { getFormatedAmount } from './get-formated-amount';

export const getProgressInfo = ({ type, goalAmount, remain, progressFilled }: ProgressData) => {
    const hasProgress =
        (type === 'GOAL_TOTAL' || type === 'GOAL_TOTAL_FOR_EACH') &&
        remain &&
        goalAmount &&
        typeof progressFilled === 'number';

    if (hasProgress) {
        const formatedGoal = getFormatedAmount(goalAmount);
        const formatedRemain = getFormatedAmount(remain);

        return {
            value: progressFilled * 100,
            text: `Осталось ${formatedRemain} из ${formatedGoal}`,
        };
    }

    return undefined;
};
